module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_5_t.5ad19e79.jpg";